export default {"src":"/_next/static/media/visa.cb8e3a97.svg","height":292,"width":292};